import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  Image,
  mergeClasses,
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';

import DefaultCompanyPageLogo from '../../media/default-company-page-logo.png';

const useComponyPageItemStyles = makeStyles({
  companyPageItem: {
    display: 'flex',
  },
  image: {
    width: '48px',
    height: '48px',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginLeft: '8px',
  },
  name: {
    fontWeight: 'bold',
    lineHeight: '20px',
    color: tokens.colorNeutralForeground1,
  },
  industry: {
    lineHeight: '20px',
    fontSize: tokens.fontSizeBase200,
  },
});

export const ComponyPageItem = (props) => {
  const {
    companyPageName,
    companyPageLogoSrc,
    industryLocation,
    industryType,
  } = props;

  const classes = useComponyPageItemStyles();
  const industry = industryType && industryLocation ? `${industryType} · ${industryLocation}` : (industryType || industryLocation);

  return (
    <div className={mergeClasses('company-page-item', classes.companyPageItem)}>
      <Image src={companyPageLogoSrc || DefaultCompanyPageLogo} alt={companyPageName} className={classes.image} />
      <div className={classes.details}>
        <Text className={mergeClasses('company-page-name', classes.name)}>
          {companyPageName}
        </Text>
        { industry && <Text className={mergeClasses('company-page-industry', classes.industry)}>{industry}</Text>}
      </div>
    </div>
  );
};

ComponyPageItem.propTypes = {
  companyPageName: PropTypes.string.isRequired,
  companyPageLogoSrc: PropTypes.string,
  industryLocation: PropTypes.string,
  industryType: PropTypes.string,
};

ComponyPageItem.defaultProps = {
  companyPageLogoSrc: '',
  industryLocation: '',
  industryType: '',
};
